// preloaderInit();
// function preloaderInit() {
//   var bodyElement = document.querySelector('body');
//   var preloader = document.querySelector('.preloader');

//   function removePreloader() {
//     if (preloader !== null) {
//       preloader.classList.add('loaded');
//       setTimeout(function() {
//         if (preloader.parentNode) {
//           preloader.parentNode.removeChild(preloader);
//         }
//       }, 900);
//     }
//   }

//   // Wait for DOM content to be loaded
//   document.addEventListener('DOMContentLoaded', function() {
//     removePreloader();
//   });

//   // Wait for all resources to be loaded
//   window.onload = function() {
//     removePreloader();
//   };
// }

preloaderInit();

function preloaderInit() {
  var preloader = document.querySelector('.preloader');
  var isRemoved = false;

  function removePreloader() {
    if (!preloader || isRemoved) {
      return;
    }

    isRemoved = true;
    preloader.classList.add('loaded');

    setTimeout(function () {
      if (preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
    }, 700);
  }

  window.addEventListener('load', function () {
    /*
     * Gives the logo animation enough time to be visible.
     */
    setTimeout(removePreloader, 500);
  });

  /*
   * Prevents the loader from getting stuck if a resource fails.
   */
  setTimeout(removePreloader, 1000);
}